import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_REPORT_DIMENSIONS,
  GET_REPORT_DIMENSIONS,
  SG_FETCH_REPORT_DIMENSION,
  FETCH_REPORT_DIMENSION,
  SG_ADD_REPORT_DIMENSION,
  ADD_REPORT_DIMENSION,
  SG_UPDATE_REPORT_DIMENSION,
  UPDATE_REPORT_DIMENSION,
  SG_DELETE_REPORT_DIMENSION,
  DELETE_REPORT_DIMENSION,
  REPORT_DIMENSIONS_PENDING,
  ALL_ERRORS,
} from "constants/actions";
import * as api from "constants/api";

function* getReportDimensions(action) {
  try {
    yield put({ type: REPORT_DIMENSIONS_PENDING });
    const response = yield call(api.GET_REPORT_DIMENSIONS, action.payload);
    yield put({ type: GET_REPORT_DIMENSIONS, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* fetchReportDimension(action) {
  try {
    yield put({ type: REPORT_DIMENSIONS_PENDING });
    const response = yield call(api.FETCH_REPORT_DIMENSION, action.payload);
    yield put({ type: FETCH_REPORT_DIMENSION, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* addReportDimension(action) {
  try {
    yield put({ type: REPORT_DIMENSIONS_PENDING });
    const response = yield call(api.ADD_REPORT_DIMENSION, action.payload);
    yield put({ type: ADD_REPORT_DIMENSION, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* updateReportDimension(action) {
  try {
    yield put({ type: REPORT_DIMENSIONS_PENDING });
    const response = yield call(api.UPDATE_REPORT_DIMENSION, action.payload);
    yield put({ type: UPDATE_REPORT_DIMENSION, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* deleteReportDimension(action) {
  try {
    yield put({ type: REPORT_DIMENSIONS_PENDING });
    yield call(api.DELETE_REPORT_DIMENSION, action.payload);
    yield put({ type: DELETE_REPORT_DIMENSION, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export default function* reportDimensionsSaga() {
  yield takeLatest(SG_GET_REPORT_DIMENSIONS, getReportDimensions);
  yield takeLatest(SG_FETCH_REPORT_DIMENSION, fetchReportDimension);
  yield takeLatest(SG_ADD_REPORT_DIMENSION, addReportDimension);
  yield takeLatest(SG_UPDATE_REPORT_DIMENSION, updateReportDimension);
  yield takeLatest(SG_DELETE_REPORT_DIMENSION, deleteReportDimension);
}